export default __webpack_public_path__ + "static/media/send.eb053011.png";